
import moment from "moment-timezone";

import { isEmpty } from './isEmpty';

/** Site display timezone (matches live/upcoming match logic). */
export const DISPLAY_TIMEZONE = "America/Chicago";

export const getTimezoneAbbrev = (dateTime) => {
    try {
        if (isEmpty(dateTime)) return "";
        return moment.tz(dateTime, DISPLAY_TIMEZONE).format("z");
    } catch (err) {
        return "";
    }
};

/** Weekday + time for game cards (timezone label shown separately). */
export const formatCommenceTime = (dateTime) => {
    try {
        if (isEmpty(dateTime)) return "";
        return moment.tz(dateTime, DISPLAY_TIMEZONE).format("dddd - hh:mm A");
    } catch (err) {
        return "";
    }
};

export const momentFormat = (dateTime, format = "dddd - hh:mm A z") => {
    try {
        if (!isEmpty(dateTime)) {
            return moment.tz(dateTime, DISPLAY_TIMEZONE).format(format);
        }
        return "";
    } catch (err) {
        return "";
    }
};

export const momentFormatUpperCase = (dateTime, format = "ddd - hh:mm A z") => {
    try {
        if (!isEmpty(dateTime)) {
            return moment.tz(dateTime, DISPLAY_TIMEZONE).format(format).toUpperCase();
        }
        return "";
    } catch (err) {
        return "";
    }
};
